import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Rect, { width: "13", height: "8", x: "8", y: "6", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "18", cy: "20", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "9", cy: "20", r: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BaggageClaim";
const BaggageClaim = memo(themed(Icon));
export {
  BaggageClaim
};
//# sourceMappingURL=baggage-claim.js.map
